<div
  class="banner w-100 d-none d-lg-flex"
  role="banner"
  [style.background-image]="isHomePage ? '' : 'url(' + ('banners/banner-background.png' | contentAssetImage) + ')'"
>
  <div class="container d-flex flex-row align-items-center justify-content-between">
    @if (isHomePage) {
      <div class="d-flex flex-column align-items-start">
        <a routerLink="/account">
          <h5
            class="fw-bold card-name d-flex align-items-center flex-row text-white text-uppercase"
            *ngIf="memberDetails$ | async as memberDetails"
          >
            {{ 'banner.welcome' | translate }} {{ memberDetails.FirstName }} !

            <span class="material-symbols-outlined text-white fw-bold"> chevron_right </span>
          </h5>
        </a>

        <div class="membership-id" *ngIf="card$ | async as card">
          <span *ngIf="(card.ProductCode | productCode | translate) === 'Season Ticket Member'"
            >{{ 'member.card.membership.label' | translate }}
          </span>
          <span *ngIf="(card.ProductCode | productCode | translate) !== 'Season Ticket Member'"
            >{{ 'member.card.membership.buyer.label' | translate }}
          </span>

          <span> {{ card.ExternalRefNumber }}</span>
        </div>
      </div>
    } @else {
      <h5 class="fw-bold banner-title text-white text-uppercase mb-0">{{ bannerTitle }}</h5>
    }
    <img class="banner-image" [src]="'banners/banner-text.png' | contentAssetImage" draggable="false" />
  </div>
</div>
